export const API_URL = 'https://ww2.provasdeti.com.br';
